import { postData } from '../plugins/ApiCalls'

export function createVisitByKey(key, data) {
  return postData('forms/' + key + '/visits/bykey', data, { emulateJSON: true })
}
